
















































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AssessmentForm, BudgetAssessment } from "@/entities";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import AuthService from "@/services/auth.service";
import LeftNavigationComponent from "./components/LeftNavigation.vue";
import NavButtons from "@/components/common/Buttons/NavButtons.vue";
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import { AppConstants as _app } from "@/shared/app.constants";
import { Locales } from "@/i18n/locales";

const auth = new AuthService();
const namespace: string = "assessmentForm";

@Component({
  components: {
    VJsonschemaForm,
    LeftNavigationComponent,
    NavButtons,
    ValidationMessageComponent
  }
})
export default class BudgetReviewWorkspaceComponent extends Vue {
  @State(namespace) internalReview!: AssessmentForm;
  @Action("getData", { namespace }) getData: any;
  @Action("getTemplate", { namespace }) getTemplate: any;
  @Action("updateBudgetActiveKey", { namespace }) updateKey: any;
  @Action("updateLanguage", { namespace }) updateLanguage: any;
  @Action("saveBudgetReview", { namespace }) saveReviewData: any;
  @Action("dirtySaveBudgetReview", { namespace }) dirtySaveBudgetReview: any;
  @Action("submit", { namespace }) submitReviewData: any;
  @Getter("budgetAssessment", { namespace }) form: BudgetAssessment;
  @Action("showNotification", { namespace: "application" }) showNotification: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Action("getDataByApplication", { namespace }) getDataByApplication: any;
  @Action("getApplicationSection", { namespace }) getApplication: any;

  formValid = true;
  showSideBar = true;
  isSubmitted = false;
  schemaformKey: number = 0;
  budgetConclusion = _app.budgetConclusion;
  isDirty: boolean = false;
  reviewId: number = 0;
  update: number = 0;
  selectedTopMenu: string = "budget";
  entity: string;
  completedBy: string;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  beforeMount() 
  {
     if (this.$route.params && this.$route.params.applicationId)
      {
        const id = parseInt(this.$route.params.applicationId);
        this.$services.reviewinternal
        .reviewSummary(id, this.entity)
        .then((resp) => {
          this.completedBy=resp['ddReview']['UserName']
          })
     }
     else
     {
          this.completedBy='';
     }
  }
  mounted() {}

  sidebarToggle() {
    this.showSideBar = !this.showSideBar;
  }

  download() {
    this.$services.budgetAssessmentPdf.print(
      this.form.templates,
      this.form.data,
      this.options,
      this.appSummary
    );
  }

  validationMessageClicked(val: any) {
    if (val.SubSectionKey) {
      this.$router.push({
        name: "budgetReview",
        params: { applicationId: this.appSummary.ApplicationId.toString() },    
        hash: `#${val.SubSectionKey}`
      }).catch(() => {})
    }
    this.form.showValidationDialog = false;
    this.form.validationMessages = [];
  }

  validationMessageClosed() {
    this.form.showValidationDialog = false;
    this.form.validationMessages = [];
  }

  submitAssessment() {
    const self = this;
    let {appSummary, validations} = self.$services.reviewinternal.budgetSummary(
      self.form.templates,
      self.form.data
    );
    this.form.validationMessages = validations;
    if (appSummary.propsCount != appSummary.filledProps) {
      this.form.showValidationDialog = true;
      // this.showNotification({
      //   text: "Please score all sections and provide a conclusion to proceed",
      //   color: "error"
      // });
    } else {
      let datum = {
        id: self.internalReview.internalReviewId,
        context: "budget",
        data: self.form.data
      };
      this.saveReviewData(datum).then(res => {
        if (res.Result === "OK") {
          this.submitReviewData(datum).then(data => {
            if (data) {
              const key: string = "intReviewSubmitted";
              this.$router.push({
                name: "genericNotification",
                query: { msgId: key }
              });
            }
          });
        }
      });
    }
  }

  /** date conversion */
  formattedDate() {
    var date;
    if (this.form.data.auditInfo) {
      date = this.form.data.auditInfo.updatedDate
        ? this.form.data.auditInfo.updatedDate
        : new Date();
    } else {
      date = new Date();
    }
    return this.$services.format.formatUTC(date);
  }

  /** open a read only view of application in new tab */
  openApplication(applicationId) {
    if (this.entity == "ConceptNote") {
      let routeData = this.$router.resolve({
        name: "viewConceptNote",
        params: { conceptNoteId: applicationId, section: 'technicalApplication' }
      });
      window.open(routeData.href, "_blank");
    }
    else {
      let routeData = this.$router.resolve({
        name: "viewApplication",
        params: { appId: applicationId, section: 'technicalApplication' }
      });
      window.open(routeData.href, "_blank");
    }
  }

  /** update the selected key on top menu selection */
  topMenuChanged(key) {
    this.selectedTopMenu = key;
  }

  /** navigation button action */
  navigate(key) {
      this.updateKey(key);
      window.location.hash = `#${key}`;
  }

  /**  update the sub menu on left panel selection */
  subMenuChanged(selectedMenu, key) {
      this.updateKey(key);
      window.location.hash = `#${key}`;
    this.schemaformKey += 1;
    if (this.$refs.budgetReview) {
      this.$refs.budgetReview["scrollTop"] = 0;
    }
  }

  get appSummary() {
    return this.internalReview.applicationSection.appHeader;
  }

  get options() {
    return {
      userInfo: {
        userName: this._username,
        updatedUserBa:this.completedBy
      },
      modifiedAt: this.formattedDate(),
      readOnly:true,
      disableAll:true,
      locale: this.defaultLocale
      // completedBy:this.completedBy
    };
  }

  /** get child schema properties to populate the left panel*/
  get subSchema(): any {
    if (this.form.templates && this.form.templates.properties) {
      var schema = this.form.templates.properties[this.form.selectedKey];
      if(schema)
        schema["x-virtual"] = false;
      return schema;
    } else {
      return {};
    }
  }

  /** set is-dirty flag  */
  /*setDirtyFlag(flag: boolean) {
    this.isDirty = flag;
  }*/

  /** back to summary page */
  back(appId) {
      this.$router.push({
        name: "readOnlyInternalReviewSummary",
        params: { applicationId: appId}
      });
  }

  /** save budget assessment */
  /*saveReview(context: string) {
    this.saveReviewData({
      data: this.form.data,
      id: this.internalReview.internalReviewId,
      context
    }).then((resp: any) => {
        if (resp) {
          this.setDirtyFlag(false);
        }
    });
  }

  saveDirty(callback: any) {
    const self = this;
    if (this.isDirty) {
      let datum = {
        id: self.internalReview.internalReviewId,
        data: self.form.data,
        context: "budget"
      };
      this.dirtySaveBudgetReview(datum).then(res => {
        if (res.Result === "OK") {
          callback();
        }
      });
    } else {
      callback();
    }
  }*/

  showError(e) {
    console.log(e);
  }
  /** change event */
  /*showChange(e) {
    this.setDirtyFlag(true);
  }
  showInput(val) {
    this.setDirtyFlag(true);
  }*/

  /** application data */
  get datum(): any {
    return this.form.data;
  }

  get saveStatus() {
    if (
      this.internalReview.reviewHeader.BudgetReviewSubmitted &&
      this.internalReview.reviewHeader.BudgetReviewSubmitted == 1
    ) {
      return false;
    } else {
      return true;
    }
  }

  /** watch methods */
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any) {
    if (changedRoute && changedRoute.name === "readOnlyBudgetReview") {
      if(this.$route.hash)
        this.form.selectedKey = this.$route.hash.substr(1);
      else
        window.location.hash = `#${this.form.selectedKey}`;

      if (this.$route.params && this.$route.params.applicationId) {
        const id = parseInt(this.$route.params.applicationId);
        this.entity = this.$route.params.entity;
        if (!this.internalReview || !this.internalReview.reviewHeader) {
          this.getDataByApplication({id: id, entity: this.entity});
          this.getApplication({id: id, entity: this.entity});
        }
      }
      this.update += 1;
      // this.$services.application
      //   .getApplicationData(this.form.data.applicationId)
      //   .then(data => {
      //     this.appSummary = data;
      //   });
    }
  }

  @Watch("form.data") chng(val) {
    this.schemaformKey += 1;
  }

  @Watch("$vuetify.lang.current")
  onPropertyChanges(value: any, oldvalue: any) {
    this.updateLanguage(value);
  }
}
